import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import * as api from '../services/api';

export default function MagicLoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [errorMessage, setErrorMessage] = useState('');
  
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus('error');
        setErrorMessage('Token no proporcionado');
        return;
      }

      try {
        const response = await api.verifyMagicLink(token);
        
        // Store auth data
        localStorage.setItem('token', response.token);
        localStorage.setItem('user', JSON.stringify(response.user));
        
        setStatus('success');
        
        // Trigger login callback
        onLogin(response.user);
        
        // Redirect after short delay
        setTimeout(() => {
          if (response.user.role === 'referidor') {
            navigate('/portal-referidos');
          } else {
            navigate('/');
          }
        }, 1500);
        
      } catch (error) {
        setStatus('error');
        setErrorMessage(error?.response?.data?.detail || 'El enlace es inválido o ha expirado');
      }
    };

    verifyToken();
  }, [token, navigate, onLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-100 to-slate-200">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {status === 'verifying' && (
            <>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Verificando acceso...</h2>
              <p className="text-slate-500">Por favor espera un momento</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">¡Acceso verificado!</h2>
              <p className="text-slate-500">Redirigiendo al panel...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="w-8 h-8 text-red-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Error de verificación</h2>
              <p className="text-slate-500 mb-6">{errorMessage}</p>
              <button
                onClick={() => navigate('/login')}
                className="w-full py-3 text-white font-semibold rounded-xl bg-slate-800 hover:bg-slate-700 transition-colors"
              >
                Volver al inicio de sesión
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
